import { BaseElementWithoutShadowDOM } from '@theme/base-element'
import quickShopContext from '@theme/context-quickshop'
import { WithModalDialog } from '@theme/mixin-with-modal-dialog'
import { ContextConsumer } from '@theme/vendor-lit'

export class QuickShop extends WithModalDialog(BaseElementWithoutShadowDOM) {
  constructor(...args) {
    super(...args)
    new ContextConsumer(this, {
      context: quickShopContext,
      subscribe: true,
      callback: (value) => {
        this.quickShop = value
      },
    })
  }

  get $dialog() {
    return this.renderRoot?.querySelector('modal-dialog') ?? null
  }

  updated(_changedProperties) {
    super.updated(_changedProperties)
    if (this.quickShop) {
      this.$dialog.url = this.quickShop
      this.openModal()
    }
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties)

    if (!this.quickShop) {
      return this.closeModal()
    }
  }
}

customElements.define('quick-shop', QuickShop)
